import gql from 'graphql-tag';

export default id => gql`
  query {
    getInvoiceUnitById(input: { id: "${id}" }) {
      id
      type
      accountId
      billUnitId
      originalId
      parentId
      invoiceType
      invoiceDelivery
      company
      invoiceDate
      startDate
      endDate
      dueDate
      status
      total
      due
      taxId
      message
      paymentTerm
      filePath
      customerAddress {
        type
        street
        extraLine
        landmark
        city
        state
        country
        postalCode
      }
      returnAddress {
        type
        street
        extraLine
        landmark
        city
        state
        country
        postalCode
      }
      invoiceTransactionAttributesList {
        index
        name
        quantity
        unitPrice
        amount
        scale
        discount
        gross
        appliedStart
        appliedEnd
        itemId
        currency
        costCenter
      }
      invoiceSummaryTotal {
        taxSubTotal
        summarySubTotal
        total
        sofaTotal
      }
      invoiceSofaList {
        index
        invoiceNumber
        total
        due
        invoiceDate
      }
      invoiceTaxList {
        index
        city
        state
        jurisdiction
        taxableAmount
        taxRate
        exemptAmount
        amount
        taxCode
        taxCategory
        payment
        invoiceSummaryType
      }
      invoiceSummaryList {
        name
        itemId
        quantity
        unitPrice
        scale
        gross
        discount
        amount
        appliedStart
        appliedEnd
        taxCode
        payment
        invoiceSummaryType
        accountingCode
      }
    }
  }
`;
